import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField, Paragraph, Button } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function ChangeRelationshipPersonDialog({
  parent1Id,
  parent2Id,
  childId,
  personToChange,
  onEdit,
  ...overlay
}) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const [changedPerson, setChangedPerson] = useState(personToChange.personId)
  const finalParents = [parent1Id, parent2Id]
  const changeIndex = personToChange.personId === parent1Id ? 0 : 1
  const focusElementRef = useRef()

  const handleSubmit = () => {
    finalParents[changeIndex] = changedPerson
    onEdit(reason, finalParents[0], finalParents[1], childId)
  }

  return (
    <DialogOverlay
      {...overlay}
      focusRef={focusElementRef}
      title={t('person.relationships.editRelationshipTitle', 'Edit Relationship')}
    >
      <Paragraph size="sm">
        {t('person.relationships.editPersonBody', 'Are you sure you want to edit this person?')}
      </Paragraph>
      <Paragraph size="sm">{`${personToChange.name} (${personToChange.personId})`}</Paragraph>
      <TextField
        label={t('personId', 'Person ID')}
        value={changedPerson}
        onChange={(event) => setChangedPerson(event.target.value)}
      />
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={() => handleSubmit()} emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelEditRelationshipBtn" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
